<template>
  <div
    :class="_class"
    :style="cssVariables"
  >
    <div class="spinner" />
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    visible: {
      type: Boolean, default: false
    },
    backgroundColor: {
      type: String,
      default: 'rgba(255, 255, 255, 0.5)'
    },
    spinnerColor: {
      type: String,
      default: 'var(--primary)'
    }
  },
  computed: {
    _class () {
      return `loading ${this.visible ? 'visible' : ''}`
    },
    cssVariables () {
      return {
        '--background-color': this.backgroundColor,
        '--spinner-color': this.spinnerColor
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.loading {
  background-color: var(--background-color);
  transition: opacity 200ms cubic-bezier(0.4, 0, 1, 1), backdrop-filter 200ms cubic-bezier(0.4, 0, 1, 1);
  opacity: 0;
  backdrop-filter: blur(0);
  position: absolute;
  z-index: 30;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  &.visible {
    opacity: 1;
    backdrop-filter: blur(2px);
    transition: opacity 250ms cubic-bezier(0, 0, .2, 1), backdrop-filter 250ms cubic-bezier(0, 0, .2, 1);
    pointer-events: all;
  }
  .spinner{
    opacity: var(--opacity);
    transition: opacity 500ms linear;
    width: 40px;
    height: 40px;
    border-top: 3px solid var(--spinner-color);
    border-right: 3px solid transparent;
    border-radius: 50%;
    animation: rotation .8s linear infinite;
  }
}

@keyframes rotation{
  from{
    transform: rotate(0deg);
  }
  to{
    transform: rotate(360deg);
  }
}
</style>
